/// <reference types="./css.d.mts" />
export function var$(content, default$) {
  return ((("var(--" + content) + ", ") + default$) + ")";
}
